<template lang="pug">
    .validating
      Header( v-model="choosingType" :name="getTypeBlock")

      Body( :type="choosingType" :userList="dataUser")

</template>
<script>
import Header from './layouts/Header';
import Body from './layouts/Body';
// import {mapActions} from 'vuex';

export default {
  components: {
    Header,
    Body
  },
  props: {},
  data() {
    return {
      choosingType: 'Статистика'
    };
  },
  computed: {
    getTypeBlock() {
      return 'Проверка заданий';
    },
    dataUser() {
      return [
        {
          id: 1,
          name: 'Дядя Вася',
          icon: '/lms/img/user.jpg',
          specialty: 'Специализация',
          type: 'lider',
          text: 'Описание о человеке/контент, Описание о человеке / контент. Описание о человеке/контент'
        },
        {
          id: 2,
          name: 'Дядя Вася',
          icon: '/lms/img/user.jpg',
          specialty: 'Специализация',
          type: 'guard',
          text: 'Описание о человеке/контент, Описание о человеке / контент. Описание о человеке/контент'
        },
        {
          id: 3,
          name: 'Дядя Вася',
          icon: '/lms/img/user.jpg',
          specialty: 'Специализация',
          type: 'volonter',
          text: 'Описание о человеке/контент, Описание о человеке / контент. Описание о человеке/контент'
        }
      ];
    }
  },
  mounted() {},
  methods: {
    // ...mapActions('validating',{})
  }
};
</script>
